import { useMemo } from 'react';
import { format } from 'date-fns';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';

export default function useCaption(areaMap?: CultureIndexAreaMap) {
  const caption = useMemo(() => {
    if (!areaMap || !areaMap.params.culture || !areaMap.params.stage
        || !areaMap.params.periodStart || !areaMap.params.periodEnd) {
      return '';
    }

    const cultureName = areaMap.params.culture.label;
    const stageName = areaMap.params.stage.label;
    const startDate = format(new Date(areaMap.params.periodStart), 'dd/MM/yy');
    const endDate = format(new Date(areaMap.params.periodEnd), 'dd/MM/yy');

    return `${cultureName} (${stageName}) ${startDate} a ${endDate}`;
  }, [areaMap]);

  return caption;
}
